export const base64image = b64 => `data:image/png;charset=utf-8;base64,${b64}`